import axios, { AxiosError, AxiosInstance } from "axios";
import { BASE_URL } from "src/config/config";
import i18n from "src/config/i18n";
import { handleErrorMsgMapper } from "src/utils/Mapper/errorMsgMapper";
import { notifyError } from "src/components/Common/Toast";

export const authAxios: AxiosInstance = axios.create({
  baseURL: BASE_URL, // 기본 서버 주소 입력
  headers: {
    "Content-Type": "application/json",
    // "Set-Cookie":
    //   "JSESSIONID=A1B6E13BB2DC097775A38B4D4DC1028D; Path=/eco-cloud; Secure; HttpOnly; SameSite=None",
    // Authorization: `Bearer ${recoil?.token?.accessToken}`,
  },
});
authAxios.defaults.withCredentials = true; // 요청시 쿠키 담아서 보내기 허용옵션

// authAxios.interceptors.request.use(async (config) => {

//   if (config.headers && accessToken) {
//     config.headers.authorization = `Bearer ${accessToken}`; // 헤더에 accessToken 추가
//     return config;
//   } else return await new Promise(() => {});
// });

authAxios.interceptors.response.use(
  (config) => {
    // 응답을 받고나서 데이터 가공이 필요할때
    // accessToken 만료됐으면 refreshToken으로 재발급할것
    // refreshToken 만료시 다시 로그인 ㄱㄱ
    // console.log("------응답 받은 후-------");
    // console.log("config", config);
    // setIsLoading(false);
    return config;
  },
  async (e: AxiosError | any) => {
    if (e?.response?.data?.errorCode === "NOT_FOUND_DATA") {
      return await new Promise(() => {});
    }
    if (
      e?.response?.data?.errorCode === "DUPLICATE_DATA" &&
      e?.request?.responseURL.includes("/cloud/service/check/url")
    ) {
      // console.log("e", e);
      throw new Error("DUPLICATE_DATA");
      // return await new Promise(() => {});
    }
    notifyError(handleErrorMsgMapper({ e }));
    // alert(handleErrorMsgMapper({ e }));
    // alert(handleErrorMsgMapper({ e }));
    if (e?.response?.data?.errorCode === "INVALID_SESSION") {
      window.sessionStorage.clear();
      window.localStorage.clear();
      if (!location.pathname.includes("/login")) {
        const lang = i18n.language;
        location.href = `/${lang}/login`;
      }
      return await new Promise(() => {});
    } else return Promise.reject(e?.response?.data);
    // alert(handleErrorMsgMapper({ e }));
    // const recoil: any = JSON.parse(
    //   window.sessionStorage.getItem("recoil") as string
    // );
    // const { accessToken, refreshToken } = recoil?.token;
    // console.log("response error발생!!", e);

    // if (e?.response && e?.response.status) {
    //   switch (e.response.status) {
    //     // status code가 401인 토큰 재발급 요청
    //     case 401:
    //       return await tokenReissue({ refreshToken })
    //         .then(async (data: any) => {
    //           // 재발급 받은 토큰값 recoil에 업데이트 후 재요청
    //           // console.log("재발급 요청에 대한 응답", data);
    //           window.sessionStorage.setItem(
    //             "recoil",
    //             JSON.stringify({
    //               ...recoil,
    //               token: {
    //                 accessToken: data.data.accessToken,
    //                 refreshToken: data.data.refreshToken,
    //               },
    //             })
    //           );

    //           e.config.headers.authorization = `Bearer ${data.data.accessToken}`;

    //           return await axios(e.config);
    //         })
    //         .catch(async (e) => {
    //           // console.log("토큰 만료 error", e);
    //           handleErrorMsgMapper({ e });
    //           return await new Promise(() => {});
    //         });

    //     // 이행되지 않는 Promise를 반환하여 Promise Chaining 끊어주기
    //     // return await new Promise(() => {});
    //     default:
    //       return await Promise.reject(e);
    //   }
    // }
  }
);
